import { Event, Occurrence } from '@tickethead/sdk';

/**
 * Determines if a particular event uses the secondary market
 *
 * @param event the event whose usage of secondary market is tested
 * @returns `true` if any of the ticket configurations on this event
 * or any of its occurrences, if present, have a defined secondary market ruleset.
 */
export function isSecondaryMarketUsed(event: Event | Occurrence): boolean {
  if (!event) {
    return false;
  }

  if ((event as Event).occurrence?.length > 0) {
    const occurrenceWithSecondary = (event as Event).occurrence.find(
      (occurrence) => isSecondaryMarketUsed(occurrence)
    );
    return occurrenceWithSecondary != null;
  }

  const ticketConfigWithSecondary = event.ticketConfig?.find(
    (ticketConfig) => ticketConfig.secondaryMarketRulesetId != null
  );
  return ticketConfigWithSecondary != null;
}
